import AnnouncementIcon from '@mui/icons-material/Announcement';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)(() => ({
  position: 'relative',
  padding: '15px',
  width: '360px',
  background: 'rgba(255, 255, 255, 1)',
  borderRadius: '6px',
  boxSizing: 'border-box',
  boxShadow: '0px 2px 10px 0px rgba(154, 154, 163, 0.25)',
}));

export const CloseButton = styled(IconButton)(() => ({
  position: 'absolute',
  right: '5px',
  top: '5px',
  zIndex: 9999,
  cursor: 'pointer',
  minWidth: '32px',
  minHeight: '32px',
  padding: '4px',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
  '&:focus': {
    outline: '2px solid #1976d2',
    outlineOffset: '2px',
  },
}));

export const IconContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '40px',
  height: '40px',
}));

export const SuccessIcon = styled(CheckCircleIcon)(() => ({
  fill: 'rgba(30, 237, 159, 1)',
}));

export const ErrorIcon = styled(CancelIcon)(() => ({
  fill: 'rgba(244, 67, 54, 1)',
}));

export const InfoIcon = styled(AnnouncementIcon)(() => ({
  fill: 'rgb(115,110,110)',
}));
